// src/utils/upload/uploadQueueManager.js

import { generateTempId } from './imageUploadHelpers';

/**
 * ✅ Create queue items from files
 */
export const createQueueItems = (files) => {
    return files.map((file) => ({
        id: generateTempId(),
        file,
        status: 'pending'
    }));
};

/**
 * ✅ Add items to queue
 */
export const addToQueue = (currentQueue, newItems) => {
    return [...currentQueue, ...newItems];
};

/**
 * ✅ Remove item from queue
 */
export const removeFromQueue = (queue, itemId) => {
    return queue.filter((item) => item.id !== itemId);
};

/**
 * ✅ Update queue item status
 */
export const updateQueueItemStatus = (queue, itemId, newStatus) => {
    return queue.map((item) =>
        item.id === itemId ? { ...item, status: newStatus } : item
    );
};

/**
 * ✅ Get next pending item
 */
export const getNextPendingItem = (queue, uploadingImages) => {
    return queue.find(
        (item) => item.status === 'pending' && !uploadingImages[item.id]
    );
};

/**
 * ✅ Update upload status
 */
export const updateUploadStatus = (uploadingImages, itemId, status, progress) => {
    return {
        ...uploadingImages,
        [itemId]: { status, progress }
    };
};

/**
 * ✅ Remove upload status
 */
export const removeUploadStatus = (uploadingImages, itemId) => {
    const updated = { ...uploadingImages };
    delete updated[itemId];
    return updated;
};

/**
 * ✅ Update error state
 */
export const updateErrorState = (errors, itemId, errorMessage) => {
    return {
        ...errors,
        [itemId]: errorMessage
    };
};

/**
 * ✅ Remove error state
 */
export const removeErrorState = (errors, itemId) => {
    const updated = { ...errors };
    delete updated[itemId];
    return updated;
};
